export default __webpack_public_path__ + "static/media/check_t.f018b68b.svg";